import { createSlice } from "@reduxjs/toolkit";

export const assetTypeSlice = createSlice({
    name: 'assetTypes',
    initialState: {
        value: []
    },
    reducers: {
        add: (state, action) => {
            state.value.push( action.payload );
        },
        addMany: (state, action) => {
            state.value = [ ...state.value, ...action.payload ];
        },
        setAssetTypes: (state, action) => {
            state.value = action.payload;
        }
    }
});

export const { add, addMany , setAssetTypes} = assetTypeSlice.actions;

export default assetTypeSlice.reducer;
